import { Controller } from "@hotwired/stimulus"

// Live preview of establishment forward email from the name field (Rails parameterize-style slug).
export default class extends Controller {
  static targets = ["name", "preview"]
  static values = { domain: String, format: { type: String, default: "preview" } }

  connect() {
    this.update()
  }

  update() {
    const slug = this.slugFromName(this.nameTarget.value)
    const email = `${slug}${this.domainValue}`

    if (this.formatValue === "receive") {
      this.previewTarget.textContent = `Vous recevrez à : ${email}`
    } else {
      this.previewTarget.textContent = `Aperçu : ${email}`
    }
  }

  slugFromName(name) {
    return name
      .normalize("NFD")
      .replace(/\p{M}/gu, "")
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "") || "etablissement"
  }
}
